import { reportData } from '@/api/voucherAct'

export default {
  computed: {
    curId () {
      return this.$route.query.id
    },
  },
  methods: {
    EVENT_TRACK (data_type, params = {}) {
      const { id, act_dispatch_id } = this.curGift
      const welfareParams = {
        welfare_id: id,
        voucher_id: act_dispatch_id,
      }
      const extra = [10, 5, 9, 11].includes(data_type) ? welfareParams : {}
      
      reportData(this.curId, {
        type: 22, // 本活动
        data_type,
        game_id: this.activeGameId || this.$route.query.gameid,
        ...params,
        ...extra,
      })
    },
  },
}